import React from 'react';

import {
  ThreeDStockLifestylesListItemInfoLifestyle,
  ThreeDStockLifestylesListItemInfoLifestylesSet
} from './ThreeDStockLifestylesListItemInfo.types';
import {
  FetchLifestylesSetsCacheKeys,
  UpdateLifestylesSetCacheAction
} from '../../../../../../lifestylesSets/lifestylesSetsTypes';

import { useLifestyleSelectButton } from '../../../../../../lifestyles/components/buttons/LifestyleSelectButton/hooks/useLifestyleSelectButton';

import { NextLinkHelper } from '../../../../../../../helpers/links/NextLinkHelper';
import { Translate } from '../../../../../../../helpers/Translate';
import { CheckBoxField } from '../../../../../../../helpers/FormFields/CheckBoxField';

import { words } from '../../../../../../../locales/keys';

interface ThreeDStockLifestylesListItemInfoProps {
  lifestyle: ThreeDStockLifestylesListItemInfoLifestyle;
  lifestylesSet: ThreeDStockLifestylesListItemInfoLifestylesSet | null;
  lifestylePagePath: string;
  lifestylesSetCacheKeys?: FetchLifestylesSetsCacheKeys;
  updateLifestylesSetCache: UpdateLifestylesSetCacheAction<ThreeDStockLifestylesListItemInfoLifestylesSet>;
}

function ThreeDStockLifestylesListItemInfo({
  lifestyle,
  lifestylesSet,
  updateLifestylesSetCache,
  lifestylesSetCacheKeys,
  lifestylePagePath
}: ThreeDStockLifestylesListItemInfoProps) {
  const { isSelected, handleToggleSelected } = useLifestyleSelectButton({
    lifestyle,
    lifestylesSet,
    updateLifestylesSetCache,
    lifestylesSetCacheKeys
  });

  return (
    <div className="flex px-3 py-2 items-center">
      <div className="flex-1 min-w-0 text-sm flex flex-col items-start gap-0.5">
        <NextLinkHelper
          className="font-semibold truncate max-w-full"
          dataGa="lifestyles-lifestyle-goto-lifestyle-page-link"
          href={lifestylePagePath}
        >
          <div className="absolute inset-0 z-1" />
          {lifestyle.name}
        </NextLinkHelper>

        <div className="flex gap-2 max-w-full">
          {lifestyle.nda && (
            <span className="bg-yellow-200 text-black px-1 text-xs rounded uppercase">
              <Translate id={words.nda} />
            </span>
          )}

          <span className="text-gray-500 dark:text-gray-400 text-xs uppercase">
            {lifestyle.category?.localizedName}
          </span>
        </div>
      </div>

      <div className="p-2.5 -mr-1.5 rounded-full hover:bg-gray-400/25 z-1 cursor-pointer md:hidden md:group-hover:block has-[:checked]:block group-focus-within:inline transition-color duration-150 ease-out">
        <CheckBoxField
          id="southport-patio-egg"
          name="select-lifestyle"
          checked={isSelected}
          onChange={handleToggleSelected}
          checkBoxClassName="basic-checkbox border-gray-600 dark:border-gray-400 dark:bg-gray-900"
        />
      </div>
    </div>
  );
}

export default ThreeDStockLifestylesListItemInfo;
